// @flow
import {createActions, handleActions, type ReduxReducer, type ActionType} from 'redux-actions';

import {DataLayerType} from './indexType';

export const defaultState = {
    email: '',
};

export const {
    dataLayer: {setCustomerEmail},
} = createActions({
    DATA_LAYER: {
        SET_CUSTOMER_EMAIL: (email: string): DataLayerType => ({email}),
    },
});

/**
 * Data layer information.
 */
export const dataLayer: ReduxReducer<
    DataLayerType,
    ActionType<typeof setCustomerEmail>,
> = handleActions(
    {
        /**
         * Set email.
         * @param {DataLayerType} state - Reducer state.
         * @param {ActionType<setCustomerEmail>} action - Customer email.
         * @return {DataLayerType} - New state.
         */
        [setCustomerEmail]: (
            state: {email: string},
            {payload}: ActionType<typeof setCustomerEmail>,
        ): DataLayerType => payload,
    },
    defaultState,
);
